import { leaderboardClient } from '@neptune/shared/core-apis-leaderboard-domain';
import { updateAndAppendAuthTokenToQuery } from '@neptune/shared/core-auth-domain';
import { EntityModelConverter } from '@neptune/shared/entity-domain';

import { FloatSeriesAttribute, StringSeriesAttribute } from 'domain/experiment/attribute';

export async function getValueListWidgetDownloadUrl(
  attribute: FloatSeriesAttribute | StringSeriesAttribute,
  entityId: string,
): Promise<string> {
  const requestParameters = {
    attribute: attribute.attributeName,
    holderIdentifier: entityId,
    holderType: EntityModelConverter.entityTypeToHolderType('project'),
    gzipped: true,
  };

  const url = leaderboardClient.getFloatSeriesCSVDownloadURL(requestParameters);

  const urlWithAuthToken = await updateAndAppendAuthTokenToQuery(url);
  return urlWithAuthToken;
}
